import { CKTab, CKTabList, CKTabs } from '@clearkit/react';
import capitalize from 'lodash/capitalize';
import { useLocation } from 'react-router-dom';

import useFeatureFlag from '~/hooks/account/useFeatureFlag';
import {
  integrationTabs as objectTypes,
  subTypes as tabTypes,
  types,
} from '~/lib/dataEnrichment';
import history from '~/lib/history';
import paths from '~/lib/paths';

const IntegrationTabs = () => {
  const currentPathArray = useLocation().pathname.split('/');
  const integration = currentPathArray.find((x) =>
    Object.values(types).includes(x),
  );
  const hasFlag = useFeatureFlag('x_data_enrichment_logs');

  const tabs = objectTypes[integration];
  const lastOfPath = currentPathArray[currentPathArray.length - 1];
  // Makes first tab the active tab if on base path i.e. /enrichment/salesforce
  const currentTabIndex =
    lastOfPath == integration ? 0 : tabs.findIndex((x) => x.name == lastOfPath);

  return (
    <CKTabs
      className="h-full"
      index={currentTabIndex}
      onChange={(index) => {
        history.push(paths.dataEnrichmentObject(integration, tabs[index].name));
      }}
      isBordered>
      <CKTabList aria-label="My tabs">
        {tabs.map((tab) =>
          shouldRenderTab(tab, hasFlag) ? (
            <CKTab
              key={tab.label}
              icon={tab.icon}
              label={capitalize(tab.label)}>
              {capitalize(tab.label)}
            </CKTab>
          ) : null,
        )}
      </CKTabList>
    </CKTabs>
  );
};
function shouldRenderTab(tab, hasFlag) {
  if (tab.name !== tabTypes.logs) {
    return true;
  } else {
    return hasFlag;
  }
}
export default IntegrationTabs;
